module.exports = __webpack_public_path__ + "img/dashboard-bg.955908a6.png";